let apiUrl = "https://api.nanoways.com/api/";
let domainName = window.location.protocol ? window.location.protocol+"//" : "https://";
domainName +=  window.location.host;

if (process.env.NODE_ENV === 'development') {
    domainName = "http://localhost:3000";
    apiUrl = "https://localhost:8000/api/";
}

export const DOMAIN_NAME = domainName;
export const API_URL = apiUrl;

/*Recource Event*/
export const API_SEND_FREE_CODE = API_URL + "v1/webinar/free/code";
export const API_EVENTS = API_URL + "v1/webinar/events";
export const API_EVENTDATE = API_URL + "v1/webinar/event-date/code/:code";
export const API_EVENTDATE_START = API_URL + "v1/webinar/check-start/eventDate/:eventDateId/booking/:ticketId";
export const API_JOIN_EVENTDATE = API_URL + "v1/webinar/join-event-date/:eventDateId/booking/:ticketId";
export const API_BOOKING_BY_CODE = API_URL + "v1/webinar/bookings/code";
export const API_CANCEL_TICKET = API_URL + "v1/webinar/cancel/ticket/:id";